import { useMemo } from 'react';
import config from '../../../config';
import { useStateSelector } from '../../../context/StateSelectors';
import { filterMenuByPermissions, flattenMenuLeaves } from '../../../utils/menuPermissions';

/**
 * `allowed(path)` gives the path back when the sidebar would offer that page to
 * this user, else undefined — so a dashboard card links only to a list its
 * reader can open.
 */
export default function useAllowedPath() {
    const permissions = useStateSelector((state) => state.permissions);
    const paths = useMemo(
        () =>
            new Set(
                flattenMenuLeaves(filterMenuByPermissions(config.menu, permissions || {})).map(
                    (leaf) => leaf.path
                )
            ),
        [permissions]
    );
    return (path) => (paths.has(path) ? path : undefined);
}
